import axios from 'axios';
import packageJson from '../../../package.json';
import type { Parameter } from '../../pages/Reports/QueryParam';
import { ReportExecutionResult } from "../../pages/Reports/ReportList";
import { basename } from '../../globals_VITE';

export interface Report {
  id: number;
  name: string;
  name1: string;
  description: string;
  params: Parameter[];
  config?: string,
  query: string;
  tag: string | null;
}

export interface ReportDB {
  report_id: number;
  report_name: string;
  report_name_1: string;
  report_description: string;
  params: Parameter[];
  report_config?: string,
  query: string;
  tag: string | null;
}

const toReportDB = (report: Report): ReportDB => (
    {
        report_id: report.id,
        report_name: report.name,
        report_name_1: report.name1,
        report_description: report.description,
        params: report.params,
        report_config: report.config,
        query: report.query,
        tag: report.tag,
    }
);

const fromReportDB = (report: ReportDB[]): Report[] => {
    return report.map((report) => ({
        id: parseInt(report.report_id as any),
        name: report.report_name,
        name1: report.report_name_1,
        description: report.report_description,
        params: report.params,
        config: report.report_config,
        query: report.query,
        tag: report.tag,
    }));
};

const fromReportDB1 = (report: ReportDB): Report => {
    return {
        id: Number(report.report_id),
        name: report.report_name,
        name1: report.report_name_1,
        description: report.report_description,
        params: report.params,
        config: report.report_config,
        query: report.query,
        tag: report.tag,
    };
};


export const executeReportQuery = async (
    id: number,
    params: { name: string; value: string | number | boolean | number[] }[],
    lang: string,
): Promise<ReportExecutionResult> => {
    const paramsToSend = {
        app_id: packageJson.name,
        report_id: id,
        parameters: params,
        lang,
    };
    console.log('[executeReportQuery] run report with params:', paramsToSend);
    console.log('[executeReportQuery] basename:', basename);
    // const res0 = await axios.post<any[]>(basename +'api/report/', paramsToSend);
    const res0 = await axios.post<any[]>('/report/', paramsToSend);
    const res: any = res0.data || {ok: false, data: []};
    if (res.ok) {
        if (!Array.isArray(res.data) || res.data.length == 0) {
            return { columns: ['Message'], rows: [['Empty report result']] };
        }
        console.log('[executeReportQuery] result:', res);
        const columns = Object.keys(res.data[0]);
        const rows = res.data.map((row: any) => columns.map((col) => row[col]));
        return { columns, rows };
    } else {
        return { columns: ['Message'], rows: [['Incorect report result']] };
    }
}

export const getReportsLang = async (lang: string = 'uk'): Promise<Report[]> => {
    console.log('[getReportsLang] Fetching reports');
// curl -X GET "https://cnt.theweb.place/api/pcnt/v_perm_report/?app_id=mutant&report_id=5&lang=ua"
    const path = `pcnt/v_perm_report/?app_id=${packageJson.name}&lang=${lang}&tag=prod`;
    const res = await axios.get<ReportDB[]>(path);
    return fromReportDB(res.data);
};

export interface StoredOptionQuery {
    name: string;
    description: string;
}

export const getStoredOptionQueries = async (): Promise<StoredOptionQuery[]> => {
    console.log('[getStoredOptionQueries] Fetching Stored Option Queries');
    const res = await axios.get<StoredOptionQuery[]>('pcnt/perm_select/');
    return res.data;
};

export interface StoredOption {
    value: string | number;
    label: string;
}

export const getStoredOptions = async (name: string): Promise<StoredOption[]> => {
    console.log(`[getStoredOptions] Fetching Stored Options for <${name}>`);
    const res = await axios.get<StoredOption[]>(`pcnt/perm_select/${name}/execute/`);
    return res.data;
};

export const getReportLang = async (report_id: number, lang: string): Promise<Report[]> => {
    console.log('[getReportLang] Fetching report',report_id);
    const path = `pcnt/v_perm_report/?app_id=${packageJson.name}&lang=${lang}&tag=prod&tag=prod&report_id=${report_id}`;
    const res = await axios.get<ReportDB[]>(path);
    return fromReportDB(res.data);
};

export const getReports = async (report_id?: number): Promise<Report[]> => {
    console.log('[getReports] Fetching reports with report_id:', report_id);
    const path = report_id === undefined ? 
      `pcnt/perm_report/?app_id=${packageJson.name}` : 
      `pcnt/perm_report/${packageJson.name}/${report_id}/`;
    const res = await axios.get<ReportDB[]>(path);
    return fromReportDB(res.data);
};

export const createReport = async (report: Report): Promise<Report | null> => {
    console.log('[createReport] Creating report:', report);
    const rdb = toReportDB(report);
    const res = await axios.post<Report>(`pcnt/perm_report/${packageJson.name}/`, rdb);
    return res.data;
}

export const updateReport = async (report: Report): Promise<Report> => {
    console.log('[updateReport] Updating report:', report);
    const rdb = toReportDB(report);
    const res = await axios.patch(`pcnt/perm_report/${packageJson.name}/${rdb.report_id}/`, rdb);
    const r = fromReportDB1(res.data);
    return r;
};

export const deleteReport = async (reportId: number): Promise<boolean> => {
    console.log('[deleteReport] Deleting report with ID:', reportId);
    const res = await axios.delete<any[]>(`pcnt/perm_report/${packageJson.name}/${reportId}/`);
    return res.status === 200;
};

export const getDashboardConfig = async (): Promise<any> => {
    // console.log('[getDashboardConfig] Fetching Dashboard Config');
    console.log('[API Call] Executing v_dashboard request. Current headers:', axios.defaults.headers.common);
    const res = await axios.get<any>(`pcnt/v_dashboard/?app_id=${packageJson.name}` );
    // debugger;
    return JSON.parse(res.data[0].model);
};

